import {About} from "./About";
import {Search} from "./Search";

import {TuneOn} from "../../components/Footer/TuneOn";
import { RadioSlider } from "../../components/List/Radio/RadioSlider";
import {My} from "./My";
import { LastSongs} from "../../components/List/Song/LastSongs";
import { PodcastSlider } from "../../components/List/Podcast/PodcastSlider";
import { Advertisement} from "../../components/Advertisement/Advertisement";
import {useSuspenseQueries} from "@tanstack/react-query";
import {useRadioRecommendedKey} from "../../queriesKeys/useRadioRecommendedKey";
import {useLastSongsKey} from "../../queriesKeys/useLastSongsKey";
import {usePodcastRecommendedKey} from "../../queriesKeys/usePodcastRecommendedKey";
import {PageHeader} from "../../components/PageHeader";



const HomepagePage = () => {

    const [recommended, lastSongs, lastPodcast] = useSuspenseQueries({queries: [
        useRadioRecommendedKey(),
        useLastSongsKey(),
        usePodcastRecommendedKey()
    ]})


    return (
        <main>
            <PageHeader />
            <About/>
            <Search/>
            <div className={"main"}>
                <div className={"mb-36px mt-36px unmain"}>&nbsp;</div>
                <My />
                <RadioSlider items={recommended.data} title={"Doporučená"}/>
                <Advertisement id={"AdTrackGenericInterscrollerDesktop"} />
                <hr className={"mb-48px mt-48px unmain"}/>
                <LastSongs songs={lastSongs.data} />
                <hr className={"mb-48px mt-48px unmain"}/>
                <PodcastSlider title={"Podcasty"} items={lastPodcast.data.result} />

                <hr className={"mb-48px mt-48px unmain"}/>
                <TuneOn/>
            </div>
        </main>
    )
}

export default HomepagePage;